import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { SubdomainService } from "src/app/core/_base/subdomain.service";
import { MadAuthService } from "src/app/core/mad-auth/mad-auth.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ReportingProcessService {
  constructor(
    private http: HttpClient,
    private authService: MadAuthService,
    private subdomainService: SubdomainService
  ) {}

  getValuationSpecialAssumptions(valuationId: number): Observable<{id: number, input: string}[]> {
    if (valuationId === undefined || valuationId == null) return of([])
    return this.http.get<{data: {id: number, input: string}[]}>(
      environment.baseApiUrl + `api/v2/${this.subdomainService.subDomain}/valuation-process/${valuationId}/special-assumptions`,
      {
        headers: this.authService.getAuthHeaders()
      }
    ).pipe(
      map(response => response.data)
    )
  }
}